import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route , BrowserRouter as Router , Switch ,Link ,Redirect} from 'react-router-dom';
import {isNull} from "lodash"
import * as UsersAPI from '../_DATA'
 class result extends Component {
     constructor(props){
         super(props)
         this.state={
             question_id:""
         }

     }
     componentDidMount(){
        //  let id = this.props.match.params.question_id;
        //  console.log(id,"id")
     }
    render() {
        console.log(this.props.questions,"questions from result")
        return (

            <div>
                <h3>hi</h3>
                {this.props.questions.map((question)=>{return (<div  key={question.id}>
               {/* <Route path={`/result/${question.id}`}> */}
                   <h3>dds</h3>
             {!isNull(this.props.auth)?
               <div>
              <h3>dd</h3>
             </div> :  <Redirect to="/"/>
         }
               {/* </Route> */}


              </div>

              
              )})
              
              
              
              } 
            </div>
        )
    }
}

const mapStateToProps = state =>{
    return { auth:state.authReducer , questions:Object.values(state.questionsReducer)}
  }
export default connect(mapStateToProps)(result)